<!--src/components/Common/FunctionMenu.vue-->
<template>
  <div class="function-menu">
    <div
      v-for="item in menuList"
      :key="item.key"
      class="menu-item"
      @click="handleClick(item)"
    >
      <div class="menu-icon">
        <img 
          v-if="item.svgIcon" 
          :src="item.svgIcon" 
          class="svg-icon" 
          alt=""
        >
        <i
          v-else
          :class="item.icon"
        />
        <span
          v-if="isLogin && countMap[item.key] > 0"
          class="badge"
        >
          {{ countMap[item.key] > 99 ? '99+' : countMap[item.key] }}
        </span>
      </div>
      <span class="menu-label">{{ item.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  menuList: {
    type: Array,
    required: true,
    default: () => []
  },
  countMap: {
    type: Object,
    required: true,
    default: () => ({})
  },
  isLogin: {
    type: Boolean,
    required: true,
    default: false
  }
})

const emit = defineEmits(['menu-click'])
const { menuList, countMap, isLogin } = props
const handleClick = (item) => {
  emit('menu-click', item)
}
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";

.function-menu {
  display: grid;
  grid-template-columns: repeat(3, 1fr); // 3列布局
  gap: 16px;
  padding: 0 16px 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); // 移动端2列
    gap: 12px;
  }

  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }

    // 图标部分
    .menu-icon {
      position: relative;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      @include bg_color;
      @include font_color;
      border-radius: 50%;
      margin-bottom: 10px;

      i {
        font-size: 20px;
      }

      .svg-icon {
        width: 24px;
        height: 24px;
      }

      // 角标（数量提示）
      .badge {
        position: absolute;
        top: -5px;
        right: -5px;
        background-color: #ff4400;
        color: #fff;
        font-size: 10px;
        padding: 1px 5px;
        border-radius: 10px;
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
      }
    }

    // 文字部分
    .menu-label {
      font-size: 14px;
      color: #333;
      font-weight: 500;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }
}
</style>
